<template>
  <div>
    <div v-for="(item, index) in items" :key="index">
      <template>
        <h5 class="title mb-3">
          DRAM {{ index + 1 }} - {{ item.descricao_grupo }}

          <b-button variant="primary" class="mb-1 ml-2" size="sm" @click="exibeDetalhe(item.lista_codigo_lancamento)"
            v-b-tooltip.hover.html="{ variant: 'primary' }"
            title="Clique aqui para ver os lançamentos selecionados para este DRAM">
            <b-icon icon="receipt" aria-hidden="true"></b-icon>
          </b-button>

          <b-card class="mt-3">
            <b-row>
              <b-col cols="8">
                <b-form-select :disabled="desabilitaOpcoes" v-model="item.selecionado"
                  @change="montaListaOpcao(index, item.selecionado)">
                  <template slot="first">
                    <option :value="null" disabled>
                      -- Selecione uma opção --
                    </option>
                  </template>

                  <option v-for="(valor, index1) in item.lista_opcao_parcto" v-bind:value="{
                    id: index,
                    pqtdparcelas: valor.AQtdParcela,
                    pvalorparcela: valor.AVlrParcela,
                    pvalordeposito: valor.AVlrDepositoInicial,
                    ppercdeposito: valor.APercDepositoInicial,
                    pidregraparcelamento: valor.AIdRegraParcelamento,
                    pidfaixasregras: valor.AIdFaixasRegraParcelamento,
                    plancamentos: item.lista_lancamento,
                    pagrupamentos: item.lista_grupo, 
                    adescricao: valor.adescricao,
                  }" :key="index1">
                    <div v-if="valor.AQtdParcela > 0">
                      {{ formatCurrency(valor.AVlrDepositoInicial) }} +
                      {{ valor.AQtdParcela }} parcela(s) de
                      {{ formatCurrency(valor.AVlrParcela) }}
                      {{ valor.adescricao ? ` - ${valor.adescricao}` : "" }}
                    </div>
                    <div v-else>
                      {{ formatCurrency(valor.AVlrParcela) }} - DRAM à vista
                    </div>
                  </option>
                </b-form-select>
              </b-col>
              <b-col cols="2">
                <div v-if="item.urlGuia">
                  <template v-if="item.selecionado &&
                    item.selecionado.adescricao !== '' &&
                    item.selecionado.pqtdparcelas > 59
                    ">
                    <b-button size="sm" variant="primary" class="mr-1 mb-2" @click="emitirRequerimento(item.urlGuia)">
                      Emitir requerimento
                    </b-button>
                    <b-row>
                      <b-button size="sm" variant="outline-primary" class="ml-3 mr-1 mb-2"
                        @click="informacoesParcelamentoExtraordinario">
                        Informações sobre o parcelamento extraordinário
                      </b-button>
                    </b-row>
                  </template>
                  <div v-if="(item.selecionado.id === index &&
                    item.selecionado.adescricao === '' &&
                    item.selecionado.pqtdparcelas > 59) ||
                    item.selecionado.pqtdparcelas < 60
                    ">
                    <b-button size="sm" :variant="guiaSelecionada.findIndex(
                      (e) => e.id === `${index}`
                    ) !== -1
                      ? 'danger'
                      : 'primary'
                      " @click="emitirGuiaParcto(item, index)" class="mr-1">
                      <div v-if="item.selecionado.pqtdparcelas === 0">
                        {{
                          guiaSelecionada.findIndex(
                            (e) => e.id === `${index}`
                          ) !== -1
                          ? "DRAM à vista emitida"
                          : "Emitir DRAM à vista"
                        }}
                      </div>
                      <div v-else>
                        {{
                          guiaSelecionada.findIndex(
                            (e) => e.id === `${index}`
                          ) !== -1
                          ? "DRAM emitida"
                          : "Emitir DRAM"
                        }}
                      </div>
                    </b-button>
                  </div>
                </div>

                <b-row v-else>
                  <b-button v-if="listaOpcoes.findIndex((e) => e.id === index) != -1" size="sm" variant="secondary"
                    @click="limpar(index)" class="mr-1">
                    Limpar
                  </b-button>
                </b-row>
              </b-col>

              <b-col cols="2">
                <div v-if="item.urlRelatorio">
                  <div v-if="item.lista_grupo[0] == 5">
                    <b-button v-if="item.urlRelatorio" size="sm" variant="success"
                      @click="emitirRelatorio(item.urlRelatorio)" class="mr-1">
                      Ver demonstrativo ITBI 
                    </b-button>
                  </div>  
                  <div v-else> 
                    <b-button v-if="item.urlRelatorio" size="sm" variant="success"
                      @click="emitirRelatorio(item.urlRelatorio)" class="mr-1">
                      Ver lançamentos
                    </b-button>                    
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </h5>
      </template>
    </div>
    <b-row class="mt-3 float-right">
      <b-button class="my-3 mr-4" size="sm" variant="secondary" @click="fecharGuiasParcelar()">
        Retornar para opções de pagamento
      </b-button>
      <div v-if="!items[0].urlGuia">
        <b-button variant="success" class="my-3 mr-3" size="sm" :disabled="desabilitaOpcoes"
          @click.prevent="emitirGuias()">
          Confirmar seleção
        </b-button>
      </div>
    </b-row>

    <b-modal ref="modal-lancamentos" hide-footer centered>
      <div id="B" class="card right-half border-success mb-2">
        <div class="col-3 align-self-center">
          <img class="img-fluid" alt="Logo PBH" :src="$baseUrl('imgs/brasao-pbh.png')" />
        </div>
      </div>
      <div id="B" class="card right-half border-success">
        <small>
          <div class="mt-2 text-center">
            <span class="col-12 align-self-center ml-1"><b><i>LANÇAMENTOS SELECIONADOS PARA ESTE DRAM</i></b></span>
          </div>
          <hr />
          <div v-for="(lanc, index) in listaLancamentos" :key="index">
            <b-row class="ml-2 mt-2">
              <b-col sm="1" md="4"> </b-col>
              <b-col sm="2" md="8">
                <p>{{ lanc }}</p>
              </b-col>
            </b-row>
          </div>
        </small>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    desabilitaOpcoes: Boolean,
    selecionados: Array,
  },
  data() {
    return {
      btnSelecionados: [],
      guiaSelecionada: [],
      habilitaBotaoSelecionarGuia: false,
      listaOpcoes: [],
      listaParcelamentosSelec: [],
      habilitaBtnParcelamento: true,
      listaLancamentos: [],
    };
  },
  computed: {},

  methods: {
    formatCurrency: function (value) {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },

    limpar(idx) {
      this.chaveID = `${idx}`;
      this.items[idx].selecionado = null;
      this.listaOpcoes = this.listaOpcoes.filter(
        (item) => item.id != this.chaveID
      );
    },

    exibeDetalhe: async function (lista) {
      this.listaLancamentos = [];
      this.mensagemErro = [];
      for (let i = 0, l = lista.length; i < l; i++) {
        if (lista[i]) {
          this.listaLancamentos.push(lista[i]);
        }
      }
      this.abrirModal("modal-lancamentos");
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    montaListaOpcao(idx, opcao) {
      this.chaveID = `${idx}`;
      const ind = this.btnSelecionados.findIndex((e) => e.id === this.chaveID);

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionados = this.btnSelecionados.filter(
          (item) => item.id != this.chaveID
        );
      } // inclui ( clicado )
      else {
        this.btnSelecionados.push({ id: this.chaveID });
      }

      this.listaOpcoes = this.listaOpcoes.filter(
        (item) => item.id != this.chaveID
      );
      this.listaParcelamentosSelec = this.listaParcelamentosSelec.filter(
        (item) => item.id != this.chaveID
      );

      // inclui ( clicado )
      this.listaOpcoes.push(opcao);

      this.listaParcelamentosSelec.push(this.items[idx]);
    },

    emitirGuias() {
      const selecionados = this.listaOpcoes;
      const title = "emitirParcelamentosTacitos";
      const data = { title, selecionados };
      this.$emit("parcelamentoTacito", data);
    },

    downloadArquivo: async function (pathurl) {
          window.open(pathurl)
    },

    emitirGuiaParcto(item, indx) {
      const str1 = indx;
      this.chaveID = `${str1}`;

      const ind = this.guiaSelecionada.findIndex((e) => e.id === this.chaveID);

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.guiaSelecionada = this.guiaSelecionada.filter(
          (item) => item.id != this.chaveID
        );
      } // inclui ( clicado )
      else {
        this.guiaSelecionada.push({ id: this.chaveID });
        this.downloadArquivo(item.urlGuia, "emissaoDRAM");
      }
    },

    emitirRelatorio(url) {
      const link = url;
      this.downloadArquivo(link, "relatorioDRAM");
    },

    async emitirRequerimento(item) {
      let urlGuia = item;
      const link = urlGuia;
      this.downloadArquivo(link, "emissaoRequerimento");
    },

    informacoesParcelamentoExtraordinario() {
      window.open(
        `https://servicos.pbh.gov.br/servicos/i/5e7e331bd9521a26a9033510/5dc8470253fd6b5bbd99185f/servicos+divida-ativa-parcelamento-extraordinario?s=6116702e8a33ee57bf03bf5f`,
        "_blank"
      );
    },

    fecharGuiasParcelar() {
      this.desabilitaOpcoes = false;
      const title = "fecharParcelamentosTacitos";
      const data = { title };
      this.$emit("parcelamentoTacito", data);
    },

    desabilitaCampos() { },
  },
};
</script>
